import React from "react";
import UserSidebar from "../components/UserSidebar";
import TimesheetMobileView from "../components/mobile/m-timesheet/TimesheetMobileView";

const TimesheetWithSidebarPage: React.FC = () => {
  return (
    <div className="flex h-screen bg-white">
      {/* Left sidebar with user info - 1/4 of screen on larger devices */}
      <div className="hidden md:block md:w-1/4 lg:w-1/5 border-r border-gray-200">
        <UserSidebar />
      </div>

      {/* Right content area with TimesheetMobileView - 3/4 of screen on larger devices, full on mobile */}
      <div className="flex-1 overflow-auto">
        <div className="max-w-3xl mx-auto">
          {/* Mobile only - Show/Hide sidebar button */}
          <div className="md:hidden p-4">
            <button 
              className="flex items-center gap-2 text-blue-600 font-medium"
              onClick={() => {
                const sidebar = document.getElementById("mobile-sidebar");
                if (sidebar) {
                  sidebar.classList.toggle("hidden");
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="7" r="4" />
                <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
              </svg>
              User Profile
            </button>
          </div>

          {/* Mobile sidebar (hidden by default) */}
          <div id="mobile-sidebar" className="md:hidden hidden">
            <UserSidebar />
            <div className="p-4 flex justify-center">
              <button 
                className="bg-gray-200 text-gray-700 px-4 py-2 rounded"
                onClick={() => {
                  const sidebar = document.getElementById("mobile-sidebar");
                  if (sidebar) {
                    sidebar.classList.add("hidden");
                  }
                }}
              >
                Close
              </button>
            </div>
          </div>

          {/* Timesheet view */}
          <TimesheetMobileView />
        </div>
      </div>
    </div>
  );
};

export default TimesheetWithSidebarPage;
